import React from "react";
import { Link } from "react-router-dom";

import img05 from "../../../images/about/img05.jpg";
import img06 from "../../../images/about/img06.jpg";
import img07 from "../../../images/about/img07.jpg";
import img08 from "../../../images/about/img08.jpg";
import aboutBg from "../../../images/bg/about-bg02.png";

// ── Inline feature icons ──────────────────────────────────────────────────────

const IconAccuracy = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
    <circle cx="24" cy="24" r="20" stroke="#00c896" strokeWidth="2.5"/>
    <path d="M14 24l7 7 13-14" stroke="#00c896" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const IconCompliance = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
    <path d="M24 6L9 12v12c0 9.9 6.4 19.2 15 21.6C32.6 43.2 39 33.9 39 24V12L24 6z"
      stroke="#00c896" strokeWidth="2.5" strokeLinejoin="round" fill="rgba(0,200,150,0.08)"/>
    <path d="M17 24l5 5 9-10" stroke="#00c896" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const IconSpeed = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
    <path d="M24 10a18 18 0 0 1 12.7 30.7" stroke="#00c896" strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M24 10a18 18 0 0 0-12.7 30.7" stroke="rgba(0,200,150,0.3)" strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M24 28l-6-9" stroke="#00c896" strokeWidth="2.5" strokeLinecap="round"/>
    <circle cx="24" cy="28" r="3" fill="#00c896"/>
    <path d="M16 13h16" stroke="#00c896" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

// ── Component ─────────────────────────────────────────────────────────────────

const AboutSection: React.FC = () => {
  return (
    <section
      className="about pos-rel pb-140"
      style={{
        background: "#ffffff",
        borderTop: "1px solid rgba(15,32,64,0.08)",
        boxShadow: "inset 0 4px 24px rgba(15,32,64,0.03)",
      }}
    >
      <div className="container">

        {/* ── Photo collage ── */}
        <div className="about-top-image ul_li_between align-items-start">
          <div className="img-hove-effect">
            <div className="xb-img">
              {[img05, img05, img05, img05].map((img, i) => (
                <Link key={i} to="/about"><img src={img} alt="TrustEngine team" /></Link>
              ))}
            </div>
          </div>
          <div className="img-hove-effect">
            <div className="xb-img">
              {[img06, img06, img06, img06].map((img, i) => (
                <Link key={i} to="/about"><img src={img} alt="TrustEngine office" /></Link>
              ))}
            </div>
          </div>
          <div className="img-hove-effect">
            <div className="xb-img">
              {[img07, img07, img07, img07].map((img, i) => (
                <Link key={i} to="/about"><img src={img} alt="TrustEngine product" /></Link>
              ))}
            </div>
          </div>
          <div className="img-hove-effect">
            <div className="xb-img">
              {[img08, img08, img08, img08].map((img, i) => (
                <Link key={i} to="/about"><img src={img} alt="TrustEngine team" /></Link>
              ))}
            </div>
          </div>
        </div>

        {/* ── Title ── */}
        <div className="sec-title sec-title-center about-sec-title about-sec-title-two mt-45">
          <span className="sub-title mb-10">Who We Are</span>
          <h2 className="title">
            Building trust in every digital interaction across Indonesia
          </h2>
          <p className="content">
            TrustEngine is an AI-powered identity verification and compliance platform
            built for regulated industries. We help fintech, banking, healthcare, and
            government institutions verify identities instantly, screen for risk, and
            stay compliant — all through a single, developer-friendly API.
          </p>
        </div>

        {/* ── Feature Cards ── */}
        <div className="row mt-40">
          <div className="col-lg-4 col-md-6 mt-30">
            <div className="xb-feature-item">
              <div className="xb-item--inner xb-border">
                <span className="xb-item--icon"><IconAccuracy /></span>
                <div className="xb-item--holder">
                  <h2 className="xb-item--title">99.8% face match accuracy</h2>
                  <p className="xb-item--content">
                    Industry-leading biometric accuracy with liveness detection to
                    prevent spoofing and deepfake fraud.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 mt-30">
            <div className="xb-feature-item">
              <div className="xb-item--inner xb-border">
                <span className="xb-item--icon"><IconCompliance /></span>
                <div className="xb-item--holder">
                  <h2 className="xb-item--title">Regulatory compliant by design</h2>
                  <p className="xb-item--content">
                    Fully aligned with OJK, BI SNAP, and PPATK AML requirements.
                    Built for Indonesia's regulated industries from day one.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 mt-30">
            <div className="xb-feature-item">
              <div className="xb-item--inner xb-border">
                <span className="xb-item--icon"><IconSpeed /></span>
                <div className="xb-item--holder">
                  <h2 className="xb-item--title">Sub-second verification</h2>
                  <p className="xb-item--content">
                    Real-time eKYC, document OCR, and watchlist screening in under
                    500ms. No manual review required.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div className="about-bg">
        <img src={aboutBg} alt="background" />
      </div>
    </section>
  );
};

export default AboutSection;
